import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import {useRequestBigReport} from './useRequestBigReport';

import type {ReportType} from 'src/openapi/admin/models/ReportType';
import type {UserUsageCriteria} from 'src/openapi/admin/models/UserUsageCriteria';

type Props = {
    reportType: ReportType,
    userUsageCriteria: UserUsageCriteria,
    onSuccess: () => void,
    onClose: () => void,
};

export const BigReportWarningModal = ({reportType, userUsageCriteria, onSuccess, onClose}: Props) => {
    const [error, setError] = useState<string | null>(null);
    const {
        event,
        busy,
    } = useRequestBigReport({reportType, onSuccess, onFail: setError, userUsageCriteria});

    const onClick = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Generate Usage Report
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {error ? <Message color="error">{error}</Message> : null}
                The report is too big to be generated immediately. It will be created in the background
                <br/>
                and available for download in the <b>"Generated reports"</b> section.
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button variant="Type.PRIMARY" onClick={onClick} busy={busy}>
                        Generate
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
